import { useState, useRef, useEffect } from "react";
import axios from "axios";

export function useGameTimer({ API, code, isCutsceneActiveRef, onTimeUp }) {
  const [timeLeft, setTimeLeft] = useState(null);
  const [sessionDuration, setSessionDuration] = useState(3600);
  const [finalizing, setFinalizing] = useState(false);
  const sessionEndRef = useRef(null);

  // Met à jour la date de fin depuis les données session (appelé depuis fetchAll)
  const syncTimer = (session) => {
    if (session.status === "in_progress" && session.startedAt && session.duration) {
      const end = new Date(session.startedAt).getTime() + session.duration * 1000;
      sessionEndRef.current = end;
      setSessionDuration(session.duration);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (sessionEndRef.current === null) return;
      const remaining = Math.max(0, Math.floor((sessionEndRef.current - Date.now()) / 1000));
      setTimeLeft(remaining);
      if (remaining <= 0) {
        if (finalizing) return;
        if (isCutsceneActiveRef.current) return;
        setFinalizing(true);
        axios.post(`${API}/api/sessions/${code}/finalize`).catch(console.error);
        onTimeUp?.();
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [finalizing, code, API]);

  return { timeLeft, sessionDuration, syncTimer };
}